<template>
  <div
    class="flex-between flex-column align-center"
    style="height: fit-content; position: relative"
  >
    <img
      draggable="false"
      style="width: 175px; margin-top: 1rem"
      :src="logo"
      alt="Sismik Harita Logo"
    />
    <iframe
      :srcdoc="content"
      width="100%"
      height="500px"
      style="border: 0"
    ></iframe>

    <div style="margin: 5px; overflow-wrap: break-word">
      <p style="font-size: x-small; opacity: 0.6">
        Not: Deprem büyüklükleri logaritmik olarak artmaktadır. Dolayısıyla 5
        büyüklüğündeki bir deprem 4 büyüklüğündeki bir depremden 1.25 kat değil,
        10 kat büyüktür (ve yaklaşık 32 kat fazla enerji saçar). Bu grafik 10
        kat farkı gösterecek olsa daireler arasındaki büyüklük farkı anormal
        olacağı için, görsel kaygılarla iki tam büyüklük arasındaki fark 2 kat
        olacak şekilde ayarlanmıştır.
      </p>
    </div>
  </div>
</template>

<script>
import _logo from "@/assets/logo.svg";
import acorn from "acorn";

export default {
  props: {
    content: String,
  },
  data() {
    return {
      logo: _logo,
      information: { magnitudes: "a", dates: "a" },
    };
  },
  mounted() {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(this.content, "text/html");

      const scriptTag = doc.querySelector("script");
      if (scriptTag) {
        const scriptContent = scriptTag.textContent;

        // Parse JavaScript code using acorn
        const parsedCode = acorn.parse(scriptContent);

        // Traverse the AST to find the desired variables
        parsedCode.body.forEach((node) => {
          if (node.type === "VariableDeclaration") {
            node.declarations.forEach((declaration) => {
              if (declaration.id.name === "dates") {
                this.information.dates = JSON.stringify(
                  declaration.init.elements
                );
              } else if (declaration.id.name === "magnitudes") {
                this.information.magnitudes = JSON.stringify(
                  declaration.init.elements
                );
              }
            });
          }
        });
      } else {
        console.error("No script tag found in the HTML code.");
      }
    } catch (err) {
      console.log(err);
    }
  },
};
</script>
